/**
 * @param row A table row.
 * @param statusString A status string.
 * @returns `true` if the given table row's status matches the given status string.
 */
const doesRowMatchStatusString = (row, statusString) => {
	return Object.keys(row).some((key) => row.paidFor.indexOf(statusString) !== -1);
};

// write a function that sees if the row's status matches to the array of statuses
// if it does, return true
// if it doesn't, return false
const doesRowMatchStatusArray = (row, statusArray) => {
	/**
	 *  The structure of the array is as of follows:
	 * [{id:'E', text:'E'}, {id:'P', text:'P'}, {id:'C', text:'C'}]
	 */
	// if the array is empty, return true
	if (statusArray.length === 0) {
		return true;
	}
	return statusArray.some((status) => row.paidFor.indexOf(status.value) !== -1);
};

export default doesRowMatchStatusString;
export { doesRowMatchStatusArray };
